import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
    pointer: {
        cursor: 'pointer',
    },
});
